var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontWeights, Image, Layer, mergeStyles, MessageBar, MessageBarType, Stack, Text } from "@fluentui/react";
import { useCallback, useContext, useMemo, useState } from "react";
import { Link } from "../components/common/Link";
import { HashimukhContext } from "../index";
import { appConfigs } from "../utils/appConfigs";
import { copyToClipboard, getPageProps } from "../utils/common";
import { bkashNumber, braindingFBLogoUrl } from "../utils/constants";
import { useStyles } from "../utils/useStyles";
var getStyles = function (theme) { return ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.neutralLighter,
        marginTop: "auto",
    },
    textComponent: {
        texts: {
            root: {
                minWidth: "260px"
            }
        },
        headers: {
            root: {
                color: theme.palette.neutralSecondary,
                fontWeight: FontWeights.semibold
            }
        },
    },
    findUsStack: {},
    copiedMessageBar: {
        root: {
            maxWidth: 100,
        }
    }
}); };
var tokens = {
    container: {
        childrenGap: 36,
    },
    texts: {
        childrenGap: 8,
    }
};
var TextStack = function (props) {
    return _jsxs(Stack, __assign({ styles: props.styles.texts, tokens: tokens.texts }, { children: [props.label && _jsx(Text, __assign({ variant: 'large', styles: props.styles.headers }, { children: props.label }), void 0), props.children] }), void 0);
};
export var FooterControl = function (props) {
    var styles = useStyles(getStyles);
    var _a = useState(false), bkashCopied = _a[0], setBkashCopied = _a[1];
    var context = useContext(HashimukhContext);
    var pageProps = getPageProps(props.type);
    var contentClass = mergeStyles([
        {
            textAlign: "left",
            paddingTop: "36px",
            paddingBottom: "36px",
            boxSizing: 'border-box',
            maxWidth: pageProps.width,
            width: '100%'
        },
        props.contentClass,
    ]);
    var copyBkashNumber = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, copyToClipboard(bkashNumber.replace(/[- ]*/g, ""))];
                case 1:
                    if (!_a.sent()) return [3, 3];
                    setBkashCopied(true);
                    return [4, new Promise(function (resolve) { return setTimeout(resolve, 5000); })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    setBkashCopied(false);
                    return [2];
            }
        });
    }); }, []);
    var stayUpdatedComps = useMemo(function () {
        return (_jsx(Link, __assign({ target: "_blank", href: appConfigs.contacts.facebook, printView: _jsx(Stack, __assign({ tokens: { childrenGap: 8 }, horizontal: true, verticalAlign: "center" }, { children: _jsxs(Text, { children: ["Facebook: ", appConfigs.contacts.facebookShort] }, void 0) }), void 0) }, { children: _jsx(Image, { src: braindingFBLogoUrl, alt: "Find us on Facebook at " + appConfigs.contacts.facebookShort, width: "96px" }, void 0) }), void 0));
    }, []);
    return (_jsx(Layer, __assign({ className: mergeStyles(styles.root), hostId: props.hostId }, { children: _jsx(Stack, __assign({ horizontalAlign: props.horizontalAlign }, { children: _jsxs(Stack, __assign({ className: contentClass, tokens: tokens.container, horizontal: true, wrap: true }, { children: [_jsx(Stack.Item, __assign({ grow: true }, { children: _jsxs(TextStack, __assign({ label: "Get in touch", styles: styles.textComponent }, { children: [_jsxs(Text, { children: ["Phone: ", _jsx(Link, __assign({ href: "tel:" + appConfigs.contacts.number }, { children: appConfigs.contacts.number }), void 0)] }, void 0), _jsxs(Text, { children: ["Email: ", _jsx(Link, __assign({ href: "mailto:" + appConfigs.contacts.email }, { children: appConfigs.contacts.email }), void 0)] }, void 0)] }), void 0) }), void 0), _jsx(Stack.Item, __assign({ grow: true }, { children: _jsx(TextStack, __assign({ label: "Donate", styles: styles.textComponent }, { children: _jsxs(Stack, __assign({ tokens: { childrenGap: 16 }, horizontal: true, verticalAlign: "center" }, { children: [_jsx(Text, __assign({ className: mergeStyles({ cursor: "pointer" }), onClick: copyBkashNumber }, { children: "Bkash: " + bkashNumber }), void 0), bkashCopied &&
                                        _jsx(MessageBar, __assign({ styles: styles.copiedMessageBar, messageBarType: MessageBarType.success }, { children: "Copied" }), void 0)] }), void 0) }), void 0) }), void 0), _jsx(Stack.Item, __assign({ grow: context.inPrintMode }, { children: context.inPrintMode
                            ? _jsx(TextStack, __assign({ label: "Stay Updated", styles: styles.textComponent }, { children: stayUpdatedComps }), void 0)
                            : _jsx(Stack, __assign({ styles: styles.findUsStack }, { children: stayUpdatedComps }), void 0) }), void 0)] }), void 0) }), void 0) }), void 0));
};
//# sourceMappingURL=FooterControl.js.map